module.exports = __webpack_public_path__ + "static/img/circle_active.30e685e8.svg";